import { Component, inject, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBolt, faCartPlus, faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { CartService } from '../../service/cart-service';
import { GiftBoxService } from '../../service/gift-box-service';
import { Product as ProductModel } from '../../models/product';
import { SelectedProduct } from '../../models/selected-product';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ItemsLoading } from '../items-loading/items-loading';
import { ProductService } from '../../service/product-service';
import { OrderService } from '../../service/order-service';
import { firstValueFrom } from 'rxjs';
import { SlicePipe } from '@angular/common';
@Component({
  selector: 'app-product',
  imports: [FontAwesomeModule, RouterLink, ItemsLoading, SlicePipe],
  templateUrl: './product.html',
  styleUrl: './product.scss'
})
export class Product {
  @Input() imageSrc: string = 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=800&q=80';
  @Input() title: string = 'Product Title';
  @Input() price: number = 49.99;
  @Input() oldPrice?: number;
  @Input() id?: string;
  @Input() product: ProductModel | undefined;
  faBolt = faBolt;
  faCartPlus = faCartPlus;
  faBoxOpen = faBoxOpen;
  private cartService = inject(CartService);
  private giftBoxService = inject(GiftBoxService);
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);
  protected addToCartLoading: boolean = false;
  private orderService = inject(OrderService);

  addToGiftBox() {
    if (this.product) {
      this.giftBoxService.addItem(this.product);
    } else {
      this.giftBoxService.addItem({
        id: this.id || 'prod-' + Date.now(),
        name: this.title,
        price: this.price,
        category: 'preset',
        image: this.imageSrc,
        quantity: 1,
      });
    }
    this.snackBar.open(`🎁 Added "${this.title}" to your Gift Box!`, 'View Box', {
      duration: 3500,
    }).onAction().subscribe(() => {
      this.router.navigate(['/gifts']);
    });
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/placeholder.svg';
  }

  async addToCart() {
    this.addToCartLoading = true;
    const selectedProduct: SelectedProduct = {
      id: this.product?.id!,
      product: this.product!,
      size: this.product?.sizes[0]!,
      color: this.product?.colors[0]!,
      price: this.product?.price!,
      oldPrice: this.product?.oldPrice!,
      images: this.product?.images!,
      quantity: 1
    }

    const available = await firstValueFrom(this.orderService.checkProductAvailability(selectedProduct));
    if (!available.available) {
      this.snackBar.open("Sorry, this product is currently out of stock.", 'Close', { duration: 5000 });
      this.addToCartLoading = false;
      return;
    }

    this.cartService.addToCart(selectedProduct).subscribe({
      next: (res) => {
        this.snackBar.open("Item added to cart successfully!", 'Close', { duration: 5000 });
        this.addToCartLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.snackBar.open("Failed to add item to cart!", 'Close', { duration: 5000 });
        this.addToCartLoading = false;
        if (error?.message === 'User not logged in') {
          this.router.navigate(['/sign-in']);
        }
      }
    });

  }

  getTotalStock(): number {
    if (!this.product?.availableCombinations?.length) return 0;

    return this.product.availableCombinations.reduce((total, combo) => {
      return total + (combo.quantity || 0);
    }, 0);
  }
}
